export default "__VITE_ASSET__d1153e8d__"